// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18tWV","rightAdornment":"Header_rightAdornment__2-DYk"};